import { useRef, useState } from "react";

import { PropallyApiFactory } from "@/module/CustomApiFactory";

export const useSendPasswordResetLink = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sentEmail, setSentEmail] = useState<string | null>(null);
  const submitting = useRef(false);

  const sendPasswordResetLink = async (data: { email: string }) => {
    if (submitting.current) return;
    submitting.current = true;
    setError("");
    setLoading(true);
    try {
      await PropallyApiFactory().v1PasswordResetsPost(data);
      // このAPIはアカウントの有無にかかわらず201を返す。表示も区別しない。
      setSentEmail(data.email);
    } catch {
      setError("ネットワークエラーです。しばらくたってからお試しください");
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return { sendPasswordResetLink, loading, error, sentEmail };
};

export const useResetPassword = (passwordResetToken: string | null) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);
  const submitting = useRef(false);

  const resetPassword = async (data: { password: string; password_confirmation: string }) => {
    if (submitting.current || !passwordResetToken) return;
    submitting.current = true;
    setError("");
    setLoading(true);
    try {
      await PropallyApiFactory().v1NewPasswordsPost({ ...data, password_reset_token: passwordResetToken });
      setComplete(true);
    } catch (e) {
      if (e.response?.status === 404) setInvalidToken(true);
      else if (e.response?.status === 422) setError("パスワード変更に失敗しました。入力内容を確認してください");
      else setError("ネットワークエラーです。しばらくたってからお試しください");
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return { resetPassword, loading, error, complete, invalidToken };
};
